import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import PageWrapper from '../components/PageWrapper';
import LoadingPage from '../components/LoadingPage';
import { userAllowed } from '../helpers/utils';
import LoginRedirectPage from '../components/LoginRedirectPage';
import AccessDeniedPage from '../components/access-denied/AccessDeniedPage';

const LazyEnterpriseSelectionPage = lazy(() => import('../components/admin/EnterpriseSelectionPage'));

const SuspenseComponent = ({ Component, props }) => (
    <Suspense fallback={<LoadingPage />}>
        <Component {...props} />
    </Suspense>
);

const PrivateRoute = ({ requiredRole, component: Component, ...rest }) => {
    const {
        signedIn,
        roles: userRoles,
        admin,
        enterpriseId,
        enterpriseName,
        enterpriseEcpdId,
        isRentalNib,
        hostEnterpriseName,
        hostEnterpriseEcpdId,
        solutionType,
        isPMEC
    } = useSelector((state) => state.auth);
    const showEnterpriseSelection = signedIn && admin === true && !enterpriseId;
    return (
        <Route
            {...rest}
            render={(props) => (
                <PageWrapper
                    {...rest}
                    signedIn={signedIn}
                    showEnterpriseSelection={showEnterpriseSelection}
                    admin={admin}
                    enterpriseId={enterpriseId}
                    enterpriseName={enterpriseName}
                    ecpdId={enterpriseEcpdId}
                    isRentalNib={isRentalNib}
                    hostEnterpriseName={hostEnterpriseName}
                    hostEnterpriseEcpdId={hostEnterpriseEcpdId}
                    isPMEC={isPMEC}
                    isIBC={solutionType === 'IBC'}>
                    {signedIn ? (
                        showEnterpriseSelection ? (
                            <SuspenseComponent Component={LazyEnterpriseSelectionPage} props={props} />
                        ) : userAllowed(userRoles, requiredRole, true) ? (
                            <SuspenseComponent key={enterpriseId} Component={Component} props={props} />
                        ) : (
                            <AccessDeniedPage props={props} />
                        )
                    ) : (
                        <LoginRedirectPage />
                    )}
                </PageWrapper>
            )}
        />
    );
};

export default PrivateRoute;
